import { call, put } from "redux-saga/effects";
import { setUserFilters } from "../../entities/userFilters";
import { requestGetUserFilters } from "../requests/userFilter";

export function* handleGetUserFilters(action) {
  try {
    const response = yield call(requestGetUserFilters);

    if (!response || !response.data) {
      console.error("API odgovor je undefined ili nema podatke");
      return;
    }

    const { data } = response;
    yield put(setUserFilters(data));
  } catch (error) {
    console.error("Greška u handleru:", error);
  }
}
